import { EOnboardingChosenReason, EOnboardingDiscoverySource, ESalaryRange } from '@constants';
import { IOnboarding, IUser } from '@sdk/contracts';
import { Form, FormInstance, Input, Row, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

import { DiscoverySourceSelector } from '../Form/DiscoverySourceSelector';
import { ReasonChooseSelector } from '../Form/ReasonChooseSelector';
import { SalaryRangeSelector } from '../Form/SalaryRangeSelector';

type StudentExtraDataFormProps = {
  form: FormInstance<IUser>;
  onboarding?: Partial<IOnboarding>;
  onOnboardingChange: (values: Partial<IOnboarding>) => void;
};

export const StudentExtraDataForm: React.FC<StudentExtraDataFormProps> = ({
  form,
  onboarding,
  onOnboardingChange
}) => {
  const { t } = useTranslation('StudentProfileConfigurationTranslations');
  const { t: tCommon } = useTranslation('DefaultTranslations');
  const watchedCurrentlyWorking = Form.useWatch(['userInfo', 'currentlyWorking'], form);

  const onChangeCurrentlyWorking = (value: boolean) => {
    form.setFieldValue(['userInfo', 'currentlyWorking'], value);
  };

  const onChangeSalaryRange = (value: ESalaryRange) => {
    form.setFieldValue(['userInfo', 'salaryRange'], value);
  };

  const onChangeDiscoverySource = (value: EOnboardingDiscoverySource) => {
    onOnboardingChange({ discoverySource: value });
  };

  const onChangeReasonChoose = (value: EOnboardingChosenReason) => {
    onOnboardingChange({ chosenReason: value });
  };

  return (
    <>
      <Form.Item name="_id" hidden>
        <Input />
      </Form.Item>
      <Row>
        <Form.Item label={tCommon('HOW_HEARD_ABOUT_US')}>
          <DiscoverySourceSelector
            value={onboarding?.discoverySource}
            onChange={onChangeDiscoverySource}
            disableDescription
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item label={tCommon('WHY_CHOOSE_US')}>
          <ReasonChooseSelector
            value={onboarding?.chosenReason}
            onChange={onChangeReasonChoose}
            disableDescription
          />
        </Form.Item>
      </Row>
      <Row>
        <Form.Item
          name={['userInfo', 'currentlyWorking']}
          label={t('CURRENTLY_WORKING')}
          valuePropName="checked">
          <Switch
            checkedChildren={t('YES')}
            unCheckedChildren={t('NO')}
            onChange={onChangeCurrentlyWorking}
          />
        </Form.Item>
      </Row>
      <Row>
        {watchedCurrentlyWorking && (
          <Form.Item name={['userInfo', 'currentlyWorkingAt']} label={t('CURRENTLY_WORKING_AT')}>
            <Input />
          </Form.Item>
        )}
      </Row>
      <Row>
        {watchedCurrentlyWorking && (
          <Form.Item name={['userInfo', 'salaryRange']} label={t('SALARY_RANGE')}>
            <SalaryRangeSelector onChange={onChangeSalaryRange} />
          </Form.Item>
        )}
      </Row>
    </>
  );
};
